import { token } from '../../utils';

export default token('borderStyle', [{
    key: 'solid',
    value: 'solid',
}]);